import { render } from "./ContactInformation.vue?vue&type=template&id=310a6296&scoped=true"
import script from "./ContactInformation.vue?vue&type=script&lang=js"
export * from "./ContactInformation.vue?vue&type=script&lang=js"

import "./ContactInformation.vue?vue&type=style&index=0&id=310a6296&lang=css"
import "./ContactInformation.vue?vue&type=style&index=1&id=310a6296&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310a6296"]])

export default __exports__